/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPaypal = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M10.372 7.103a.775.775 0 0 1 .768-.657h4.872c.578 0 1.116.038 1.608.117.333.052.661.13.982.234.242.08.466.175.674.284.244-1.555-.002-2.614-.843-3.573C17.506 2.452 15.833 2 13.69 2H7.474a.888.888 0 0 0-.878.75l-2.59 16.414a.534.534 0 0 0 .527.618h3.838l.964-6.114z" />
        <path
          clipRule="evenodd"
          d="M17.62 6.562a6.469 6.469 0 0 1 .981.235c.232.076.458.171.674.284.334.172.634.404.886.683.792.903.947 2.188.648 3.726-.717 3.682-3.17 4.955-6.305 4.955h-.484a.778.778 0 0 0-.769.657l-.039.212-.609 3.865-.032.165a.778.778 0 0 1-.768.656H8.568a.465.465 0 0 1-.461-.54l.264-1.678.934-5.923a.888.888 0 0 1 0-.002l.03-.19 1.037-6.564a.776.776 0 0 1 .768-.658h4.872a10.13 10.13 0 0 1 1.608.117zm-3.057 6.245c2.32-.614 4.037-2.22 4.648-5.361l.005-.024-.005.024c-.611 3.14-2.328 4.747-4.648 5.36z"
          fillOpacity={0.5}
          fillRule="evenodd"
        />
      </g>
    </g>
  </Icon>
);
export { SvgPaypal as Paypal };
